export default __webpack_public_path__ + "static/media/RunHorseLight_5_2.64390865.jpg";